import APIRequestState from './_util/api-request';

class RedeemReferralState extends APIRequestState {
  get method() { return 'GET'; }
  get url() { return '/credit/redeem'; }
}

export default RedeemReferralState;



// WEBPACK FOOTER //
// ./spa/state/redeem-referral.jsx